const state = {
    show: false
  }
  
  const mutations = {
    SET_LOADING(state, show) {
      state.show = show
    }
  }
  
  const actions = {
    setLoading({ commit }, show) {
      commit('SET_LOADING', show)
    }
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  } 